module.exports = __webpack_public_path__ + "static/media/clock-icon-glowing.b4ddc10a.png";